import Blog from "@/Layouts/Blog";
import Hero from "@/Sections/Hero";
import { Head } from "@inertiajs/inertia-react";
import Contact from "@/Sections/Contact";

import {
    BookOpenIcon,
    CashIcon,
    CheckIcon,
    ClockIcon,
    HomeIcon,
    UserGroupIcon,
} from "@heroicons/react/solid";

export default function AboutPage() {
    const information = [
        {
            name: "Locatie: Uden",
            icon: HomeIcon,
        },
        {
            name: "Duur: 2 tot 3 uur",
            icon: ClockIcon,
        },
        {
            name: "Aantal personen: Op maat (minimaal 5 personen)",
            icon: UserGroupIcon,
        },
        {
            name: "Heerlijke snack na de workout",
            icon: CheckIcon,
        },
        {
            name: "GRATIS Boek ‘Succesvol afvallen zonder voedingsschema’ voor alle werknemers",
            icon: BookOpenIcon,
        },
        {
            name: "Kosten: Op aanvraag",
            icon: CashIcon,
        },
    ];

    const values = [
        {
            name: "1. Vertrouwen",
            description:
                "Onderling vertrouwen is essentieel voor een succesvolle onderneming. Met WE ARE TEAMBUILDING vergroten we dit vertrouwen en vertalen we praktische werksituaties naar sportieve uitdagingen.",
        },
        {
            name: "2. Samenwerking",
            description:
                'Net als in het bedrijfsleven kunnen successen niet worden behaald zonder samenwerking. Dit geldt ook voor onze sportieve uitdagingen. Door samen te werken kunnen uw medewerkers de opdrachten succesvol afronden binnen de gestelde tijd. Ons motto "één team, één taak" benadrukt dat iedereen nodig is om te slagen, van directeur tot receptioniste.',
        },
        {
            name: "3. Volharding",
            description:
                "Rome is niet in één dag gebouwd, en dat geldt ook voor onze sportieve uitdagingen en uw bedrijf. Tijdens onze activiteiten leren we vasthouden aan een plan totdat het beoogde doel is bereikt. We trainen de wil om door te zetten tot het einde en maken korte metten met dat tweede stemmetje in het hoofd.",
        },
        {
            name: "4. Plezier",
            description:
                "Plezier is wellicht het belangrijkste element. Zonder plezier is niets mogelijk. Daarom bieden we naast het verbeteren van de samenwerking en het trainen van doorzettingsvermogen een onvergetelijke ervaring voor het gehele team, waarin wordt gestreden maar ook veel wordt gelachen.",
        },
    ];

    return (
        <Blog>
            <Head>
                <title>
                    Teambuilding - WE ARE Personal Training Uden en Schijndel
                </title>
                <link rel="canonical" href={route("course.team-building")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="Jouw transformatie binnen 12 weken? Bij WE ARE personal training Uden en Schijndel regelen we het! Geen resultaat = geld terug!"
                />
                <meta
                    property="og:description"
                    content="Jouw transformatie binnen 12 weken? Bij WE ARE personal training Uden en Schijndel regelen we het! Geen resultaat = geld terug!"
                />
                <meta
                    property="og:url"
                    content={route("course.team-building")}
                />
                <meta property="og:type" content="website" />
                <meta
                    property="og:title"
                    content="Teambuilding - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/personal-training-uden-schijndel.png"
                />
            </Head>

            <div className="bg-black">
                <Hero homepage={false} header={"Team building"}></Hero>

                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                    <div className="max-w-4xl mx-auto">
                        <h2 className="block text-white mx-auto font-custom italic font-bold uppercase max-w-4xl xs:text-4xl sm:text-4xl md:text-4xl lg:text-5xl mt-8 text-center">
                            Sportieve teambuilding voor uw organisatie!
                        </h2>
                        <p className="mt-4 text-lg text-gray-100 text-center">
                            Bent u als werkgever op zoek naar een sportieve
                            teambuilding-activiteit voor uw werknemers? Dan is
                            WE ARE TEAMBUILDING de ideale keuze voor u!
                        </p>
                    </div>
                    <div
                        className={`relative xs:pt-8 sm:pt-8 md:pt-16 lg:pt-16`}
                    >
                        <div className="relative max-w-7xl mx-auto">
                            <p className="mt-2 text-3xl font-bold tracking-tight text-white sm:text-4xl text-center">
                                Onze kernwaarden
                            </p>
                            <div className="lg:mt-24 md:mt-12 sm:mt-12 xs:mt-12 mx-auto grid gap-5 lg:grid-cols-2 max-w-none">
                                {values.map((value, key) => (
                                    <div
                                        key={key}
                                        className="flex flex-col rounded-lg shadow-lg overflow-hidden"
                                    >
                                        <div className="flex-1 bg-black p-6 flex flex-col justify-between">
                                            <div className="flex-1">
                                                <div className="block mt-2">
                                                    <p className="text-xl font-bold text-center text-gray-100 text-we-are-yellow">
                                                        {value.name}
                                                    </p>
                                                    <p className="text-lg text-center mt-2 text-gray-100">
                                                        {value.description}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <img
                                src="/assets/business/maatwerk-organisatie.jpg"
                                alt="Team building"
                                className="mt-12"
                            />
                        </div>
                    </div>

                    <div className="overflow-hidden py-12 sm:py-16">
                        <div className="mx-auto max-w-7xl px-6 lg:px-8">
                            <p className="mt-2 text-3xl font-bold tracking-tight text-white sm:text-4xl">
                                Programma-opzet
                            </p>
                            <p className="mt-6 text-lg leading-8 text-white">
                                Gedurende twee tot drie uur worden uw
                                medewerkers fysiek en mentaal uitgedaagd om tot
                                het uiterste te gaan. Een voorbeeld van een
                                sportieve uitdaging is onze "Tree Trunk",
                                waarbij het team een zware boomstam van punt A
                                naar punt B moet verplaatsen binnen een bepaalde
                                tijd. Tijdens deze activiteit zijn leiderschap
                                en samenwerking cruciaal. Ook andere uitdagingen
                                zoals de "Wheel Flip" en "Leave Nothing & Nobody
                                Behind" vormen een stevig fundament voor
                                teambuilding. Welke onderdelen precies
                                terugkomen in de training stellen we samen op
                                basis van wensen en fitheid van de groep.
                            </p>
                            <p className="mt-6 text-lg leading-8 text-white">
                                Na een fysieke en mentale inspanning leren we om
                                weer 'uit' te schakelen. Het is belangrijk voor
                                u en uw team om bewust bezig te zijn met het
                                'aan' en 'uit' leren staan wanneer nodig, om
                                uitval op de werkvloer te voorkomen. Met onze
                                "Rest & Digest" activiteit brengen we onszelf
                                van 'aan' naar 'uit' en komen we tot rust.
                            </p>
                            <p className="mt-6 text-lg leading-8 text-white">
                                We sluiten gezamenlijk af met een verfrissende
                                snack en een schrijfsessie. We evalueren wat we
                                hebben geleerd van de fysieke en mentale
                                uitdagingen en stellen doelen op voor onszelf en
                                het team, waar u in de komende weken aan kunt
                                werken. Een groepsfoto als afsluiting maakt de
                                ervaring compleet!
                            </p>
                        </div>

                        <div className="mx-auto max-w-7xl px-6 lg:px-8 mt-12 xs:mt-8 sm:mt-8 md:mt-12 lg:mt-12">
                            <p className="mt-2 text-3xl font-bold tracking-tight text-white sm:text-4xl">
                                <span className="text-we-are-yellow">
                                    Gratis{" "}
                                </span>
                                boek: Succesvol afvallen zonder voedingsschema
                            </p>
                            <p className="mt-6 text-lg leading-8 text-white">
                                Na afloop van deze sessie ontvangen alle
                                medewerkers ons zorgvuldig samengestelde boek.
                                Dit naslagwerk stelt hen in staat om hun mentale
                                ontwikkeling verder te verdiepen en te
                                versterken. Het boek biedt informatie,
                                waaronder: praktische opdrachten om inzichten
                                toe te passen, herkenbare praktijkvoorbeelden,
                                onderbouwde psychologische theorieën
                            </p>
                            <p className="mt-6 text-lg leading-8 text-white">
                                Deze combinatie ondersteunt uw medewerkers bij
                                hun persoonlijke groei op de lange termijn. Het
                                boek fungeert als een gids, waarmee zij kunnen
                                werken aan hun mentale weerbaarheid en welzijn.
                            </p>
                        </div>
                        <div className="mx-auto max-w-7xl px-6 lg:px-8 mt-12 xs:mt-8 sm:mt-8 md:mt-12 lg:mt-12">
                            <p className="mt-2 text-3xl font-bold tracking-tight text-white sm:text-4xl">
                                Praktische informatie
                            </p>
                            <dl className="mt-10 max-w-xl space-y-8 text-base leading-7 text-white lg:max-w-none">
                                {information.map((feature) => (
                                    <div
                                        key={feature.name}
                                        className="relative pl-9"
                                    >
                                        <dt className="inline font-semibold text-white">
                                            <feature.icon
                                                aria-hidden="true"
                                                className="absolute left-1 top-1 h-5 w-5 text-we-are-yellow"
                                            />
                                            {feature.name}
                                        </dt>{" "}
                                        <dd className="inline">
                                            {feature.description}
                                        </dd>
                                    </div>
                                ))}
                            </dl>
                        </div>
                    </div>
                </div>

                <Contact />
            </div>
        </Blog>
    );
}
